import { Card } from "react-bootstrap";
import MessageCard from "./MessageCard";
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

const JobMessages = (props) => {
    const allMessages = props.messages;

    /**
     * Handle messagecard click.
     * @param {number} index
     */
    const handleMessageCardClick = (index) => {
        // Extract the message ID from the chosen message using the index
        const messageId = allMessages[index].id;

        props.history.push({
            pathname: "/messagecenter",
            search: `?messageId=${messageId}`,
            state: { fromJob: true }
        });
    }

    if (allMessages.length === 0) {
        return <></>;
    }

    return (
        <Card className='fullwidth-mobile invoice-messagecenter-messages'>
            <h3
                id='heading-job-messages'
                className='ps-3 pe-3'
            >
                {props.title}
            </h3>
            <div className='scrollable-content '>
                {allMessages.map((message, index) => {
                    const nextIndex = index < allMessages.length - 1 ? index + 1 : '';
                    const activeIndex = -1;
                    return (
                        <div key={'message-' + message.id}>
                            <button
                                id={"message-" + message.id}
                                className="btn messagecard mb-2"
                                onClick={() => handleMessageCardClick(index)}
                            >
                                <MessageCard
                                    cardIndex={index}
                                    id={message.id}
                                    status={message.current_status.status}
                                    statusCode={message.jobstatus}
                                    dueDate={message.due_date}
                                    summary={message.summary}
                                    invoiceNumber={message.jobid}
                                    invoiceDpid={message.dpid}
                                    creditor={message.creditor}
                                    activeIndex={activeIndex}
                                    isUnread={message.current_status.unread}
                                    hideInvoiceLink={true}
                                    {...props}
                                />
                            </button>

                            {/* do not show spacers before/after the chosen card*/}
                            <hr className={'mb-2 ' + (activeIndex === index || activeIndex === nextIndex ? 'hide' : '') + " d-none d-sm-block"} />
                        </div>
                    );
                })}
            </div>
        </Card>
    )
}

JobMessages.propTypes = {
    history: PropTypes.any,
    messages: PropTypes.array,
    title: PropTypes.string
}

export default withRouter(JobMessages);
